import { createFileRoute } from "@tanstack/react-router";
import { SignLayout } from "#/features/sign/components/sign-layout";

export const Route = createFileRoute("/_app/sign")({
	component: SignLayout,
});
